import { createAction } from 'typesafe-actions';
import { Extension, Store } from '../types';

export const setStores = createAction('STORES/SET', action => {
  return (stores: Store[]) => action(stores);
});

export const setSortOrder = createAction('STORES/SET-SORT-ORDER', action => {
  return sortOrder => action(sortOrder);
});

export const setSearchQuery = createAction('STORES/SET-SEARCH-QUERY', action => {
  return (searchQuery: string) => action(searchQuery);
});

export const fetchStoreExtensions = createAction('EXTENSIONS/FETCH-STORE-EXTENSIONS', action => {
  return (id: number) => action(id);
});

export const setStoreExtensions = createAction('EXTENSIONS/SET-STORE-EXTENSIONS', action => {
  return (storeId: number, extensions: Extension[]) => action({ storeId, extensions });
});

export const openStoreExtensions = createAction('EXTENSIONS/OPEN-STORE-EXTENSIONS', action => {
  return (storeId: number, isOpen: boolean) => action({ storeId, isOpen });
});

export const setExtensionsSearchQuery = createAction('EXTENSIONS/SET-SEARCH-QUERY', action => {
  return (storeId: number, searchQuery: string) => action({ storeId, searchQuery });
});

export const makeIWSCall = createAction('IWS/MAKE-CALL', action => {
  return (numberToDial: string) => action(numberToDial);
});
